import type { Movie } from '@/mocks/movies';

interface MovieCardProps {
  movie: Movie;
  rank?: number;
  dark?: boolean;
}

export default function MovieCard({ movie, rank, dark = false }: MovieCardProps) {
  return (
    <article
      className={`group relative rounded-lg overflow-hidden border transition-transform duration-300 hover:-translate-y-1 cursor-pointer ${
        dark ? 'bg-foreground-900 border-foreground-800' : 'bg-background-50 border-background-200'
      }`}
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden">
        <img
          src={movie.poster}
          alt={`${movie.title} 影片封面`}
          title={`${movie.title} 星辰影院最新电影`}
          className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/85 via-black/10 to-transparent" />

        {typeof rank === 'number' && (
          <span className="absolute top-2 left-2 w-8 h-8 flex items-center justify-center rounded-md bg-primary-500 text-background-50 font-heading text-lg leading-none">
            {rank}
          </span>
        )}

        {typeof rank !== 'number' && movie.isTodayUpdate && (
          <span className="absolute top-2 left-2 px-2 py-0.5 rounded-md bg-accent-500 text-foreground-950 text-[11px] font-bold">
            今日更新
          </span>
        )}

        <span className="absolute top-2 right-2 flex items-center gap-1 px-2 py-0.5 rounded-md bg-black/55 backdrop-blur-sm text-accent-300 text-xs font-semibold">
          <i className="ri-star-fill text-[11px]" />
          {movie.rating.toFixed(1)}
        </span>

        <div className="absolute bottom-0 left-0 right-0 p-3">
          <h3 className="text-background-50 text-sm md:text-base font-bold leading-snug line-clamp-2">{movie.title}</h3>
          <p className="mt-1 text-[11px] md:text-xs text-foreground-300 leading-relaxed line-clamp-2">{movie.tagline}</p>
        </div>
      </div>

      <div className="p-3">
        <div className="flex flex-wrap gap-1.5">
          {movie.genres.slice(0, 2).map((g) => (
            <span
              key={g}
              className={`px-2 py-0.5 rounded-full text-[11px] ${
                dark ? 'bg-foreground-800 text-foreground-200' : 'bg-secondary-100 text-secondary-900'
              }`}
            >
              {g}
            </span>
          ))}
          <span className={`px-2 py-0.5 rounded-full text-[11px] ${dark ? 'bg-foreground-800 text-foreground-300' : 'bg-background-100 text-foreground-600'}`}>
            {movie.duration} 分钟
          </span>
        </div>
        <p className={`mt-2 text-[11px] md:text-xs ${dark ? 'text-foreground-400' : 'text-foreground-500'}`}>
          {movie.year} · {movie.region}
        </p>
      </div>
    </article>
  );
}